import React, { useEffect, useState } from "react";
import Web3 from "web3";
import { useAppKitAccount } from "@reown/appkit/react";
import { useConnectorClient } from "wagmi";
import { ITreasureContract,ReserveContract  } from "../config/contractConfig";
import ITreasureContractABI from "../abis/ITreasureContractABI.json";
import ReserveContarctABI from "../abis/ReserveContarctABI.json";

import Loader from "../components/Loader";

import Nodata from "../assets/img/no-record-found.png";

import {
  FaWallet,
  FaHashtag,
  FaMoneyBillWave,
  FaBoxOpen,
  FaClock,
  FaCopy,
  FaCheck,
  FaFilter
} from "react-icons/fa";

const AllBonusLog = () => {
  const { address, isConnected } = useAppKitAccount();
  const { data: client } = useConnectorClient();

  const [web3, setWeb3] = useState(null);
  const [bonusList, setBonusList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  // ⭐ FILTER STATES
  const [searchValue, setSearchValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [bonusFilter, setBonusFilter] = useState(""); // dropdown filter
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const recordsPerPage = 15;
  const formatBalance = (balance) =>
    balance ? parseFloat(balance).toFixed(4) : "0.00";

  // INIT WEB3
  useEffect(() => {
    const initWeb3 = () => {
      let provider = null;

      if (client?.transport) provider = client.transport;
      else if (window.ethereum) provider = window.ethereum;

      if (!provider) return;

      const w3 = new Web3(provider);
      setWeb3(w3);
    };

    initWeb3();
  }, [client]);

  // BONUS TYPE NAME LOGIC
  const getBonusName = (type) => {
    switch (Number(type)) {
      case 1:
        return "Referral Bonus";
      case 2:
        return "Level Bonus";
      case 3:
        return "Royalty Bonus";
      case 6:
      return "Trading Level Bonus";
      default:
        return "Unknown Bonus";
    }
  };

  // FETCH DATA
  useEffect(() => {
    if (isConnected && address && web3) fetchAllBonuses();
  }, [address, isConnected, web3]);

  // const fetchAllBonuses = async () => {
  //   setLoading(true);
  //   try {
  //     const contract = new web3.eth.Contract(
  //       ITreasureContractABI,
  //       ITreasureContract
  //     );

  //     const result = await contract.methods.reward_details(address).call();

  //     const reward_timestamp = result._reward_timestamp || [];
  //     const reward_credited = result._reward_credited || [];
  //     const reward_type = result._reward_type || [];
  //     const reward_level = result._reward_level || [];
  //     const reward_from = result._reward_from || [];
  //     const reward_package = result._reward_package || [];
  //    const reward_flag = result._reward_flag || [];
  //     if (reward_type.length === 0) {
  //       setBonusList([]);
  //       setLoading(false);
  //       return;
  //     }

  //     const formatted = reward_type
  //       .map((type, i) => {
  //         const rawDate = new Date(Number(reward_timestamp[i]) * 1000);

  //         return {
  //           bonus_name: getBonusName(type),
  //           from: reward_from[i],
  //           amount: Web3.utils.fromWei(
  //             reward_credited[i].toString(),
  //             "ether"
  //           ),
  //           level: Number(reward_level[i]),
  //           timestamp: rawDate.toLocaleString(),
  //           dateRaw: rawDate, // ⭐ date filter required
  //           package: Number(reward_package[i]),
  //           type: Number(type),
  //            // ⭐ STATUS LOGIC
  //           status: Number(reward_flag[i]) === 1 ? "Success" : "Flushed",
  //           statusFlag: Number(reward_flag[i])
  //         };
  //       })
  //       .reverse();

  //     setBonusList(formatted);
  //   } catch (error) {
  //     console.error("❌ Fetch Error:", error);
  //   }
  //   setLoading(false);
  // };

  const fetchAllBonuses = async () => {
    if (!address || !web3) return;

    setLoading(true);
    try {
      // =====================
      // 1️⃣ TREASURE CONTRACT
      // =====================
      const treasure = new web3.eth.Contract(
        ITreasureContractABI,
        ITreasureContract
      );

      const res1 = await treasure.methods
        .reward_details(address)
        .call();

      const list1 = res1._reward_type.map((type, i) => {
        const rawDate = new Date(
          Number(res1._reward_timestamp[i]) * 1000
        );

        return {
          bonus_name: getBonusName(type),
          amount: Web3.utils.fromWei(
            res1._reward_credited[i].toString(),
            "ether"
          ),
          from: res1._reward_from[i],
          level: Number(res1._reward_level[i]),
          type: Number(type),
          statusFlag: Number(res1._reward_flag[i]),
          status:
            Number(res1._reward_flag[i]) === 1
              ? "Success"
              : "Flushed",
          timestamp: rawDate.toLocaleString(),
          dateRaw: rawDate,
          package: Number(res1._reward_package[i]),
        };
      });

      // ==========================
      // 2️⃣ TRADING LEVEL CONTRACT
      // ==========================
      const trading = new web3.eth.Contract(
        ReserveContarctABI,
        ReserveContract
      );

      const res2 = await trading.methods
        .reward_details(address)
        .call();

      const list2 = res2._reward_type.map((type, i) => {
        if (Number(type) !== 6) return null;

        const rawDate = new Date(
          Number(res2._reward_timestamp[i]) * 1000
        );

        return {
          bonus_name: "Trading Level Bonus",
          amount: Web3.utils.fromWei(
            res2._reward_credited[i].toString(),
            "ether"
          ),
          from: res2._reward_from[i],
          level: Number(res2._reward_level[i]),
          type: 6,
          statusFlag: Number(res2._reward_flag[i]),
          status:
            Number(res2._reward_flag[i]) === 1
              ? "Success"
              : "Flushed",
          timestamp: rawDate.toLocaleString(),
          dateRaw: rawDate
        };
      }).filter(Boolean);

      // ==========================
      // 3️⃣ MERGE + SORT
      // ==========================
      const merged = [...list1, ...list2].sort(
        (a, b) => b.dateRaw - a.dateRaw
      );

      setBonusList(merged);
    } catch (err) {
      console.error("Bonus Fetch Error:", err);
    }
    setLoading(false);
  };


  // ⭐ FILTER LOGIC
  const filteredRecords = bonusList.filter((item) => {
    const search = searchValue.toLowerCase();
    const uiPackage = (item.package + 1).toString();

    // DATE FILTER
    const dateValid =
      (!fromDate || item.dateRaw >= new Date(fromDate)) &&
      (!toDate || item.dateRaw <= new Date(toDate));

    // BONUS NAME DROPDOWN FILTER
    const bonusValid =
      bonusFilter === "" ||
      item.bonus_name.toLowerCase() === bonusFilter.toLowerCase();

    // SEARCH BOX FILTER (ALL FIELDS)
    const searchValid =
      searchValue === "" ||
      item.from.toLowerCase().includes(search) ||
      item.bonus_name.toLowerCase().includes(search) ||
      item.amount.toString().includes(search) ||
      uiPackage.includes(search) ||
      item.timestamp.toLowerCase().includes(search);

    return dateValid && bonusValid && searchValid;
  });

  // PAGINATION
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );
  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage);

  const [copiedIndex, setCopiedIndex] = useState(null);

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 1500);
  };

  const resetFilters = () => {
    setSearchValue("");
    setFromDate("");
    setToDate("");
    setBonusFilter("");
  };

  if (loading) return <Loader />;
  

  return (
    <div className="buyshheikh-page">
      <h4 className="mb-3 mobilefiltername">
        <div>
          <span className="text-warning"> All </span>{" "}
          <span className="fw-lighter"> Bonus Log</span>
        </div>

        <button
          className="btn btn-light btn-sm"
          onClick={() => setMobileFilterOpen(true)}
        >
          <FaFilter /> Filter
        </button>
      </h4>

      <div className="card paddingfilter">
        <div className="card-body">
          {/* MOBILE FILTER PANEL */}
          {mobileFilterOpen && (
            <div
              className="overlay-bg"
              onClick={() => setMobileFilterOpen(false)}
            />
          )}

          <div
            className={`bottom-filter-panel ${
              mobileFilterOpen ? "show" : ""
            }`}
          >
            <div
              className="close-filter"
              onClick={() => setMobileFilterOpen(false)}
            >
              ✕
            </div>

            <div className="row">
              {/* BONUS DROPDOWN */}
              <div className="col-md-12 col-lg-3 mb-3">
                <label className="form-label">Bonus Type</label>
                <select
                  className="form-control"
                  value={bonusFilter}
                  onChange={(e) => setBonusFilter(e.target.value)}
                >
                  <option value="">All Bonus</option>
                  <option value="Referral Bonus">Referral Bonus</option>
                  <option value="Level Bonus">Level Bonus</option>
                  <option value="Royalty Bonus">Royalty Bonus</option>
                  <option value="Trading Level Bonus">Trading Level Bonus</option>
                </select>
              </div>

              {/* DATE FROM */}
              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label">From Date</label>
                <div className="input-icon">
                <input
                  type="date"
                  className="form-control"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                />
                 <i className="fa-solid fa-calendar iconposition"></i>
              </div>
          </div>

              {/* DATE TO */}
              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label">To Date</label>
                <div className="input-icon">
                <input
                  type="date"
                  className="form-control"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                />
                 <i className="fa-solid fa-calendar iconposition"></i>
              </div>
          </div>

              {/* SEARCH */}
              <div className="col-md-12 col-lg-3 mb-3">
                <label className="form-label">Search</label>
                <input
                  type="text"
                  className="form-control"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                  placeholder="Wallet"
                />
              </div>

              {/* APPLY + RESET */}
              <div className="col-md-12 col-lg-2 mb-3">
                <label className="form-label invisible">.</label>
                <div className="d-flex gap-2 mobleapplybtn">
                  <button
                    className="btn btn-success"
                    onClick={() => setMobileFilterOpen(false)}
                  >
                    Apply
                  </button>
                  <button className="btn btn-danger" onClick={resetFilters}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* DISPLAY RECORDS */}
          <div className="row">
            {currentRecords.length > 0 ? (
              currentRecords.map((item, index) => {
                const masked =
                  item.from.substring(0, 2) +
                  "****" +
                  item.from.substring(item.from.length - 2);

                return (
                  <div className="col-md-4 mb-4" key={index}>
                    <div className="ref-card">
                      <div className="ref-card-body">
                        <div className="ref-row">
                          <span className="ref-label">
                            <FaHashtag /> S.No
                          </span>
                          <span className="ref-value">
                            {indexOfFirstRecord + index + 1}
                          </span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaBoxOpen /> Bonus Name
                          </span>
                          <span className="ref-value">{item.bonus_name}</span>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaWallet /> From Wallet
                          </span>

                          <div className="ref-copy-box">
                            <span className="ref-value">{masked}</span>

                            <button
                              className="copy-btn"
                              onClick={() => handleCopy(item.from, index)}
                            >
                              {copiedIndex === index ? (
                                <FaCheck className="copy-icon copied" />
                              ) : (
                                <FaCopy className="copy-icon" />
                              )}
                            </button>
                          </div>
                        </div>

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaMoneyBillWave /> Amount (USDT)
                          </span>
                          <span className="ref-badge">
                            {formatBalance(item.amount)}
                          </span>
                        </div>

                        
                          {item.bonus_name === "Level Bonus" && (
                          <>
                            {/* LEVEL */}
                            <div className="ref-row">
                              <span className="ref-label">
                                <FaMoneyBillWave /> Level
                              </span>
                              <span className="ref-value">
                                 {item.level}
                              </span>
                            </div>
                             </>
                            )}

                        <div className="ref-row">
                          <span className="ref-label">
                            <FaMoneyBillWave /> Status
                          </span>
                        
                          <span
                            className={`ref-badge ${
                              item.statusFlag === 1 ? "badge-success" : "badge-danger"
                            }`}
                          >
                            {item.status}
                          </span>
                        </div>

                      {item.bonus_name !== "Trading Level Bonus" && (
  <div className="ref-row">
    <span className="ref-label">
      <FaBoxOpen /> Package
    </span>
    <span className="ref-value">
      {item.package + 1}
    </span>
  </div>
)}


                        <div className="ref-row">
                          <span className="ref-label">
                            <FaClock /> Date & Time
                          </span>
                          <span className="ref-date">{item.timestamp}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="no-data">
                <img src={Nodata} alt="" />
              </div>
            )}
          </div>

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="pagination-div">
              <ul className="pagination mb-0">
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllBonusLog;
